import React, { FC, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, makeStyles } from "@material-ui/core";
import { calculatingSelector } from "../store/discount/discount.selectors";
import { confirmSelections } from "../store/discount/discountReducer";

const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: theme.palette.primary.main,
    marginLeft: 20,
    height: 48,
    width: 192,
    paddingLeft: "6px",
    paddingRight: "6px",
    lineHeight: "18px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginLeft: 5,
    },
  },
}));

export const CompleteButton: FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const calculating = useSelector(calculatingSelector);
  const handleClick = useCallback((): void => {
    dispatch(confirmSelections());
  }, [dispatch]);
  return (
    <>
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={handleClick}
        disabled={calculating}
        disableElevation
      >
        Completa l&apos;acquisto
      </Button>
    </>
  );
};
